module.exports = "md-select {\n  width: 100%;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/user/signup/billing/billing.component.css
// module id = ./src/app/user/signup/billing/billing.component.css
// module chunks = main